import { useEffect } from 'react';
import {
  Col,
  Form,
  FormItem,
  Row,
  useForm,
  useShowToastNotification,
  useTranslation,
  TRtkErrorType,
  ENotificationType,
} from '@packages/utils';
import Checkbox from 'components/Base/Checkbox';
import EditableSelect from 'components/Base/EditableFields/EditableSelect';
import { InplaceEditLabels } from 'components/Base/EditableFields/components/InplaceEditLabel';
import { EIconNames } from 'components/Base/Icon';
import { useUpdateAttendanceStatusMutation } from 'redux/apiSlice/elcs.slice';
import { avatarColorMapper } from 'pages/private/ELCs/ELCs.data';
import ElcItemPopover from 'pages/private/ELCs/components/ElcPopover';
import { TGuestProps } from '../Guest.types';
import RemoveGuestAttendee from '../../RemoveGuestAttendee';

const GuestWithActions = ({ elcId, meetingId, data }: TGuestProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.attendees.other',
  });
  const { showToastNotification } = useShowToastNotification();
  const { form } = useForm<{ isAttended: boolean }>();

  const [updateAttendanceStatus, { isLoading }] =
    useUpdateAttendanceStatusMutation();

  const onEdit = () => {
    // do nothing
  };

  useEffect(() => {
    if (data) form.setFieldsValue({ isAttended: data.isAttended });
  }, [data]);

  const handleCheckboxChange = async (e: { target: { checked: boolean } }) => {
    try {
      const payload: any = {
        attendeeId: data?.attendeeId || '',
        meetingId,
        isAttended: e.target.checked,
      };

      if (elcId) {
        payload.elcId = elcId;
      }

      await updateAttendanceStatus(payload).unwrap();
      form.setFieldsValue({ isAttended: e.target.checked });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Row align="middle">
      <Col className="mr-4">
        <Form form={form} initialValues={{ isAttended: data?.isAttended }}>
          <FormItem className="mb-0" name="isAttended" valuePropName="checked">
            <Checkbox
              onChange={handleCheckboxChange}
              disabled={isLoading || !data}
              checked={data?.isAttended}
            />
          </FormItem>
        </Form>
      </Col>
      <Col>
        <InplaceEditLabels
          label={t('INPLACE_EDIT_LABEL')}
          icon={EIconNames.PROFILE}
        />
      </Col>
      <Col flex="auto">
        <EditableSelect
          {...(data && {
            title: {
              label: data.fullName,
              value: data.userId,
            },
          })}
          fitContent={false}
          options={[]}
          onEdit={onEdit}
          emptyText={t('EMPTY_TEXT')}
          placeholder={t('PLACEHOLDER')}
          readonly
          canRemove={false}
          avatarColor={avatarColorMapper.lead}
          {...(data && {
            tooltip: (
              <ElcItemPopover
                fullName={data.fullName}
                email={data.email}
                phone={data.phone || ''}
              />
            ),
          })}
        />
      </Col>
      {data && (
        <RemoveGuestAttendee
          attendeeId={data.attendeeId}
          elcId={elcId}
          meetingId={meetingId}
        />
      )}
    </Row>
  );
};

export default GuestWithActions;
